/**
 * 入住时间模块
 */
import React, { memo } from 'react';
import { connect } from 'react-redux';
import intl from 'react-intl-universal';

import ContentBlock, { FormItem } from '@/components/Reservation/ContentBlock';
import { format2FullTimeStr } from '@/utils/date';
import { OCC_TYPE_MAP, OCC_VALUE_MAP } from '@/config/constant';

import { createStateSelector } from '@/redux/actions/reservation/helper';
import { ReducerState, storeName } from '@/redux/reducers/reservation/checkInByReserve';

import styles from './index.module.scss';

const stateSelector = (state: ReducerState) => {
  const { rentTimeInfo } = state;
  return { rentTimeInfo };
};
const mapStateToProps = createStateSelector<ReducerState>(storeName, stateSelector);
const mapDispatchToProps = {};

type MapStateProps = ReturnType<typeof stateSelector>;
type MapDispatchProps = typeof mapDispatchToProps;

const Index: React.FC<MapStateProps & MapDispatchProps> = (props) => {
  const { rentTimeInfo } = props;
  const itemOccType = rentTimeInfo.occType;

  return (
    <ContentBlock
      title={intl.get('drawer_checkin_time_block_title')}
      className={styles.timeInfoContainer}
    >
      <FormItem label={intl.get('app_reservation_occ_type')}>{OCC_TYPE_MAP[itemOccType]}</FormItem>
      <FormItem
        label={intl.get('app_reservation_occ_duration')}
      >{`${rentTimeInfo.rentTime}${OCC_VALUE_MAP[itemOccType]}`}</FormItem>
      <FormItem label={intl.get('app_reservation_etd_time')}>
        {format2FullTimeStr(rentTimeInfo.expectedDepartureTime)}
      </FormItem>
    </ContentBlock>
  );
};

export default connect<MapStateProps, MapDispatchProps>(
  mapStateToProps,
  mapDispatchToProps,
)(memo(Index));
